import { Input } from 'lynkco-up-core';
import { UpdateApplications } from '../../modules/UpdateManagement/types';
import { BaseSyntheticEvent, useEffect } from 'react';

type prop = {
  appsObject: UpdateApplications | undefined;
  setappsObject: React.Dispatch<React.SetStateAction<UpdateApplications | undefined>>;
  setIsNewCar: React.Dispatch<React.SetStateAction<boolean>>;
};

const newApp: UpdateApplications = {
  name: '',
  packageName: '',
};

function CreateApplicationForm({ appsObject = newApp, setappsObject, setIsNewCar }: prop) {
  function handleInput(event: BaseSyntheticEvent): void {
    const name = event.target.name;
    const value = event.target.value;
    setappsObject({
      ...appsObject,
      [name]: value,
    });
  }

  function handleVehicleModels(event: BaseSyntheticEvent): void {
    const value = event.target.value;
    setIsNewCar(value === 'NV');
  }

  useEffect(() => {
    setappsObject(newApp);
  }, []);

  return (
    <form className="mt-4 flex flex-col">
      <section className="my-0.5 w-44">
        <Input onChange={handleInput} name="name" placeholder="App name" />
      </section>
      <section className="my-0.5 w-44">
        <Input onChange={handleInput} name="packageName" placeholder="Package name" />
      </section>

      <section className="my-0.5">
        <select onChange={handleVehicleModels} name="Car models">
          <option value={'OV'}>{'Old vehicles (CX11 A1)'}</option>
          <option value={'NV'}>{'New vehicles (CX11 A3, E335 & DX11)'}</option>
        </select>
      </section>
    </form>
  );
}

export default CreateApplicationForm;
